<template>
  <div class="content-card">
    <div class="content-img">
      <div class="bg-full bg-image" :style="{backgroundImage: `url('${ikUrl}')`}"/>
    </div>
    <div class="body">
      <span class="content-label text-muted">{{ label }}</span>
      <h3 class="content-title">{{ title }}</h3>

      <div class="content-desc">
        <slot name="description"/>
      </div>

      <div class="bar">
        <slot name="bar"/>
      </div>
    </div>
  </div>
</template>

<script>
import { urlFromAWSUrl } from '@/imagekit/imageurl_from_aws_url'

export default {
  name: 'ContentCard',
  props: {
    label: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    }
  },
  computed: {
    ikUrl() {
      return urlFromAWSUrl(this.imageUrl, [{ width: 200 }])
    }
  }
}
</script>

<style lang="less" scoped>
.content-card {
  display: flex;
  flex-flow: row nowrap;
  min-height: 200px;
  margin: 1.5em 0;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
  background: white;
}
.content-img {
  flex: 0 0 auto;
  width: 200px;
  object-fit: cover;
  position: relative;
}
.body {
  padding: 1em 1em 1em 1.5em;
  .content-label {
    font-weight: bold;
  }
  .content-title {
    margin: 0.25em 0 0.5em 0;
    font-weight: 500;
    font-size: 24px;
  }
}
.bar {
  margin-top: 1.5em;
}
</style>
